// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2roPX","actionsCol":"EnrolledClinics_actionsCol__14j6v"};